import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { lastMonthDay } from 'src/app/shared/utils/utils';

@Component({
  selector: 'app-tenant-invoices',
  template: `
    <div class="row mb-4">
      <div class="col-md-12 mt-3 pb-3">
        <h1>Facturas</h1>
        <div class="list-group rounded-4 shadow mt-4" *ngIf="invoices.length>0">
          <div 
            app-item-invoice-tenant
            class="list-group-item p-0 overflow-hidden" *ngFor="let invoice of invoices | paginate: { itemsPerPage: payFilterPrefs.per_page, currentPage: p, totalItems: meta.total_entries }"
            [invoice]="invoice"
          ></div>
        </div>
        <div class="list-group rounded-4 shadow" *ngIf="invoices.length==0">
          <div class="list-group-item text-center py-5" *ngIf="loading">
            <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
            <p class="text-muted">Cargando...</p>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="!loading">
            <img src="/assets/images/empty-state.png" width="240px">
            <h5 class="text-muted">No se encontraron registros</h5>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-end mt-4" *ngIf="invoices.length>0">
        <pagination-controls
          (pageChange)="p = $event"
          (pageChange)="pageChanged($event)"
          previousLabel="Prev."
          nextLabel="Sig."
          screenReaderPaginationLabel="Pagination"
          screenReaderPageLabel="page"                  
        ></pagination-controls>
      </div>
    </div>
  `,
  styleUrls: []
})
export class TenantInvoicesComponent {
  invoices: any[] = [];
  meta: any = {};
  permissions: any = {};
  tenant: any = {};

  profile: any = {};
  payload: any = {};

  loading: boolean = false;

  fromDate: NgbDate;
  toDate: NgbDate;
  a = new Date();

  payFilterPrefs: any = {};

  p: number = 1;
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.tenant = this.storageService.getItem(STORAGE_KEYS.USER);
    // this.payload.profile_id = this.profile.id;

    this.fromDate = new NgbDate(this.a.getFullYear(), this.a.getMonth(), 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastMonthDay(this.a.getFullYear(), this.a.getMonth()));
    //
    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;

    this.payFilterPrefs = this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) ? this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) : this.payload;
    this.payFilterPrefs.tipo = 0;
    // this.payFilterPrefs.profile_id = this.profile.id;
    this.p = this.payFilterPrefs.page;

    this.loadInvoices(this.payFilterPrefs);
  }

  loadInvoices(payload: any) {
    this.loading = true;
    this.store.getInvoicesByUnit(this.tenant.id, payload).subscribe({
      next: (invoices: any) => {
        this.invoices = invoices.data;
        this.meta = invoices.meta;
        this.loading = false;
        this.storageService.saveItem(STORAGE_KEYS.PAYFILTERSPREFS, this.payFilterPrefs);
      },
      error: (err: any) => {
        console.log(err.status);
        this.loading = false;
        this.invoices = [];
        if (err.status === 500) {
          this.toastr.error('Ocurrió un error al obtener las facturas.', 'Error');
        }
      }
    });
  }

  pageChanged(event: any) {}
}
